module.exports = __webpack_public_path__ + "static/media/Loading.9c9cf44c.svg";